import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styles from './Members.scss';
import Loading from '../Loading/Loading';
import CollectionsCard from '../Collections/CollectionCard';
import CollectionModal from '../Modal/CollectionModal/CollectionModal';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import _result from 'lodash/result';
import {
  getCollections,
} from '../../actions';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Button from '@material-ui/core/Button';
import {getCollectionCardThumbnail} from '../../lib/ImagesUtil';

const SavedProperties = (props) => {
  const {userFavourites, collections, getCollections} = props;
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [modalMode, setModalMode] = useState('CREATE');

  const CreateCollectionButton = () =>
    <Button
      variant={'contained'}
      color={'primary'}
      endIcon={<AddCircleIcon />}
      onClick={() => setShowCreateModal(!showCreateModal)}>
      Create a new collection
    </Button>;

  const DefaultCard = () => {
    if(_isEmpty(userFavourites.favourites))
      return(<></>);

    return(
      <CollectionsCard
        cardName="All Saved Properties"
        cardImageUrl={getCollectionCardThumbnail(userFavourites.favourites,'default')}
        cardCount={userFavourites.favourites.length}
        cardLink={'/members/properties'}
        menuVisible={false}
      />);
  };

  const Collections = () =>
    <div className={'pt-4 pb-4'}>
      <DefaultCard />
      { !_isEmpty(collections.list) && collections.list.map(collection =>
        <CollectionsCard
          cardName={collection.name}
          cardImageUrl={getCollectionCardThumbnail(userFavourites.favourites, 'collection', collection.propertyIds)}
          cardCount={collection.propertyCount}
          cardLink={'/members/collection?id=' + collection.collectionUuid}
          collectionUuid={collection.collectionUuid}
          key={collection.collectionUuid}
        />
      )}
    </div>;


  const DefaultContent = () =>
    <div className={'mt-4 ' + styles.content}>

      <div className={styles.emptyContent}>
        <img src={'/assets/images/savedProperties.png'} alt={'Saved Properties'}/>
        <div>
          <h3>Create a Collection</h3>
          <p>Save and organise properties into collections that you can easily keep track of and share with others.</p>
          <CreateCollectionButton/>
        </div>
      </div>
    </div>;

  useEffect(() => {
    getCollections();
  }, []);

  return (userFavourites.status === 'fetching' ? <Loading/> :
    <div className={'mt-5 mb-5 ' + styles.members}>
      <h3 className="mb-4">Saved Properties</h3>
      <p>Organise and manage your saved properties in lists that you can share with friends and family.</p>

      <CreateCollectionButton/>

      {(!_isEmpty(userFavourites.favourites) || !_isEmpty(collections.list)) ?
        <Collections /> :
        <DefaultContent/>
      }

      <CollectionModal
        showModal={showCreateModal}
        toggleModal={() => setShowCreateModal(!showCreateModal)}
        modalMode={modalMode}
        exitOnSave={true}
      />
    </div>);
};


const mapStateToProps = (state) => {
  return {
    userFavourites: state.userFavourites,
    collections: state.collections
  };
};

const mapDispatchToProps = {
  getCollections,
};

SavedProperties.propTypes = {
  userFavourites: PropTypes.object,
  collections: PropTypes.object,
  getCollections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedProperties);
